import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { InfoBannerComponent } from '@catch/general-ui';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-platform-settings-notifications',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, TranslocoPipe, InfoBannerComponent],
  templateUrl: './platform-settings-notifications.component.html',
  styleUrl: './platform-settings-notifications.component.scss',
})
export class PlatformSettingsNotificationsComponent {
  readonly form = input.required<FormGroup>();
  readonly recommendationsPaused = input(false);
}
